import React, { useEffect } from "react";
import "./AdultPhysiotherapist.css";

export default function AdultPhysiotherapist() {
  useEffect(() => {
    document.title = "Adult Physiotherapy | Gifted Child Therapy";
  }, []);

  return (
    <div className="adult-page">
      {/* Fixed Banner */}
      <div className="adult-banner-wrapper">
        <div className="adult-banner-fixed">
          <h1 className="banner-title">Advanced Physiotherapy</h1>
          <p className="banner-subtitle">
            Expert care for pain relief, mobility, and recovery
          </p>
        </div>
      </div>

      {/* Content Section */}
      <div className="adult-content container-fluid">
        <div className="row">
          {/* Fixed Image Column */}
          <div className="col-lg-4 physio-image-column">
            <img
              src="/adultPhysio/seniorPhysio.png"
              alt="Dr. Jacob Praveen"
              className="physio-profile-img-fixed"
            />
          </div>

          {/* Scrollable Content Column */}
          <div className="col-lg-8 physio-content-column">
            <h3 className="physio-name">Dr. Jacob Praveen</h3>
            <p className="physio-role">
              Senior Musculoskeletal Physiotherapist
            </p>

            <p className="page-text">
              Jacob is a{" "}
              <span className="highlight">highly experienced musculoskeletal physiotherapist</span>{" "}
              with over{" "}
              <span className="highlight">20 years of clinical practice</span>{" "}
              across public hospitals, private clinics, emergency care, and academia.
              His passion is to{" "}
              <span className="highlight">
                relieve pain, restore movement, and help individuals return to an
                active and meaningful life
              </span>
              .
            </p>

            <p className="page-text">
              He holds a{" "}
              <span className="highlight">Bachelor of Physiotherapy</span>{" "}
              and advanced postgraduate qualifications from the{" "}
              <span className="highlight">
                University of Otago, New Zealand
              </span>
              , including a{" "}
              <span className="highlight">
                Postgraduate Diploma in Manipulative Therapy
              </span>{" "}
              and a{" "}
              <span className="highlight">
                Master’s degree in Orthopaedic Manipulative Physiotherapy
              </span>
              . In 2009, he joined{" "}
              <span className="highlight">
                Changi General Hospital, Singapore
              </span>
              , gaining extensive experience in managing{" "}
              <span className="highlight">
                complex musculoskeletal and spinal conditions
              </span>
              .
            </p>

            <p className="page-text">
              Jacob{" "}
              <span className="highlight">
                specialises in the assessment and treatment of
              </span>{" "}
              <span className="highlight">
                back pain, neck pain, sacroiliac and pelvic girdle pain, sports
                injuries, and chronic pain conditions
              </span>
              . He has worked closely with the{" "}
              <span className="highlight">Accident & Emergency (A&E) Department</span>{" "}
              treating{" "}
              <span className="highlight">
                acute musculoskeletal injuries, disc-related pain, and acute
                neuropathic pain
              </span>
              —developing{" "}
              <span className="highlight">
                strong diagnostic skills and results-driven treatment strategies
              </span>
              .
            </p>

            <p className="page-text">
              His clinical approach is{" "}
              <span className="highlight">
                holistic, evidence-based, and patient-centered
              </span>
              , integrating advanced techniques such as{" "}
              <span className="highlight">
                McKenzie MDT, Mulligan’s Concept, Clinical Pilates, Muscle Energy
                Technique, Positional Release Technique, shockwave therapy,
                therapeutic exercise, and modern pain science
              </span>
              .
            </p>

            <p className="page-text">
              After six years in the public healthcare system, Jacob transitioned
              to private practice and has been part of{" "}
              <span className="highlight">Urban Rehab for over ten years</span>.
              He works closely with{" "}
              <span className="highlight">
                orthopaedic surgeons and pain specialists
              </span>{" "}
              to ensure{" "}
              <span className="highlight">
                comprehensive and efficient rehabilitation
              </span>{" "}
              tailored to each patient’s goals.
            </p>

            <p className="page-text">
              In addition to clinical practice, Jacob is a{" "}
              <span className="highlight">
                Clinical Lecturer at Nanyang Polytechnic (NYP)
              </span>{" "}
              and an{" "}
              <span className="highlight">
                Allied Health Professions Council (AHPC) Supervisor
              </span>
              , contributing to the education and development of future
              physiotherapists. He is actively involved in{" "}
              <span className="highlight">
                professional education, research presentations, community health
                talks, and sports physiotherapy coverage
              </span>{" "}
              at national and international levels.
            </p>

            <p className="page-text">
              Jacob is deeply committed to helping his patients{" "}
              <span className="highlight">
                recover fully, safely, and confidently
              </span>
              , empowering them with{" "}
              <span className="highlight">
                knowledge, skills, and long-term care strategies
              </span>{" "}
              for sustained health and wellbeing.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
